import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import {
    BehaviorSubject,
    Observable,
    Subject,
    catchError,
    exhaustMap,
    filter,
    finalize,
    map,
    of,
    retry,
    switchMap,
    take,
    tap,
    throwError,
    timeout,
    timer,
} from 'rxjs';

/** Importación del RCV en segundo plano (scrapper read-rcv, /scrapper/jobs). */
export interface RcvImportJob {
    id: string;
    kemp: number;
    year: number;
    month: number;
    estado: 'EN_CURSO' | 'OK' | 'ERROR';
    /** Etapa en curso ("Detalle de compras", …). */
    etapa: string;
    /** Avance dentro de la etapa (0/0 = sin conteo). */
    actual: number;
    total: number;
    inicio: string;
    fin: string | null;
    error?: string;
    rutsNuevos?: number;
}
import { Pagination, PaginationApi } from '../../core/types/paginate.types';
import { Rcv } from 'app/common/models/rcv.model';

interface Resume {
    orde: number;
    name: string;
    cant: number;
    suma: number;
    dctm: number;
    afec: number;
    exen: number;
    ivam: number;
    tota: number;
}

@Injectable({
    providedIn: 'root',
})
export class RcvService {
    //Privates

    private _rcvs: BehaviorSubject<Rcv[] | null> = new BehaviorSubject(null);
    private _rcv: BehaviorSubject<Rcv | null> = new BehaviorSubject(null);
    private _pagination: BehaviorSubject<Pagination | null> =
        new BehaviorSubject(null);

    private _resrcvs: BehaviorSubject<Rcv[] | null> = new BehaviorSubject(null);

    // Se emite cuando algo cambió el universo de RCV (reimportación desde el
    // SII, envío a Acuse de Recibo, etc.) para que pantallas ajenas —el botón
    // naranjo "Facturas pendientes de Acuse de Recibo" del layout classy—
    // recalculen su contador sin sondear. Mismo patrón que fevService.changed$.
    readonly changed$ = new Subject<void>();

    /* public getData(): Observable<Rcv[]>{
        const urlApi =`${environment.urlApi}/api/rcv`
        return this.http.get<Rcv[]>(urlApi)
    }*/

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for Rcvs
     */
    get rcvs$(): Observable<Rcv[]> {
        return this._rcvs.asObservable();
    }

    get resrcvs$(): Observable<Rcv[]> {
        return this._resrcvs.asObservable();
    }

    /**
     * Getter for Rcv
     */
    get rcv$(): Observable<Rcv> {
        return this._rcv.asObservable();
    }

    /**
     * Getter for pagination
     */
    get pagination$(): Observable<Pagination> {
        return this._pagination.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get rcvs
     *
     *
     * @param page
     * @param size
     * @param sort
     * @param order
     * @param search
     */
    getRcv(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nrcv',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kemp: number,
        year: number,
        mnth: number,
        oper: string,
        rutt: string = '',
        // Filtro opcional por tipo de documento (fila seleccionada en la
        // grid resumen) — null/undefined = sin filtro (usado para pedir el
        // resumen completo del período, sii/rcv toggleDetails()).
        tdoc?: number | null
    ): Observable<{ meta: PaginationApi; data: Rcv[] }> {
        console.log('--> getRcvs()');
        const url = `${environment.urlApi}/api/rcv/list-by-oper/`;
        console.log('url:', url);
        console.log('kemp', kemp);
        console.log('year', year);
        console.log('mnth', mnth);
        console.log('oper', oper);
        return this._httpClient
            .get<{ meta: PaginationApi; data: Rcv[] }>(
                url + kemp + `/` + year + `/` + mnth + `/` + oper,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby: 'nume',
                        order,
                        // search,
                        ...(rutt ? { rutt } : {}),
                        ...(tdoc !== null && tdoc !== undefined ? { tdoc: '' + tdoc } : {}),
                    },
                }
            )
            .pipe(
                tap((response) => {
                    //console.log('Get.Response', response);
                    console.log('Get.Response.meta', response.meta);
                    //this._pagination.next(response.meta);
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._rcvs.next(response.data);
                })
            );
    }

    getResRcvs(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nrcv',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kemp: number,
        year: number,
        mnth: number,
        oper: string
    ): Observable<{ meta: PaginationApi; data: Rcv[] }> {
        console.log('kemp', kemp);
        console.log('year', year);
        console.log('mnth', mnth);
        console.log('oper', oper);
        return this._httpClient
            .get<{ meta: PaginationApi; data: Rcv[] }>(
                `${environment.urlApi}/api/rcv/list-by-oper/` +
                    kemp +
                    `/` +
                    year +
                    `/` +
                    mnth +
                    `/` +
                    oper,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby: 'id',
                        order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    //console.log('Get.Response', response);
                    console.log('Get.Response.meta', response.meta);
                    //this._pagination.next(response.meta);
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._resrcvs.next(response.data);
                })
            );
    }

    getRcvsByPrvAndPeriodx(
        page: number = 0,
        take: number = 10,
        orderby: string = 'nrcv',
        order: 'ASC' | 'DESC' | '' = 'ASC',
        search: string = '',
        kprv: number = 0,
        date0: Date,
        date1: Date
    ): Observable<{ meta: PaginationApi; data: Rcv[] }> {
        //  console.log('environment.urlApi: ', environment.urlApi);
        //console.log('orderby: ', orderby);
        //console.log('orderby.split(.).length ', orderby.split('.'));
        return this._httpClient
            .get<{ meta: PaginationApi; data: Rcv[] }>(
                `${environment.urlApi}/api/c04/list/` +
                    kprv +
                    '/' +
                    date0 +
                    '/' +
                    date1,
                {
                    params: {
                        page: '' + page,
                        take: '' + take,
                        orderby:
                            orderby.split('.').length === 1
                                ? 'r_cmp_04.' + orderby
                                : orderby,
                        order,
                        // search,
                    },
                }
            )
            .pipe(
                tap((response) => {
                    //  console.log(response);
                    const take = parseInt(response.meta.take, 10);
                    const startIndex = 0;
                    const endIndex = response.data.length - 1;
                    this._pagination.next({
                        length: response.meta.itemCount,
                        size: +response.meta.take,
                        page: +response.meta.page,
                        lastPage: response.meta.pageCount,
                        startIndex:
                            (+response.meta.page - 1) * +response.meta.take,
                        endIndex:
                            (+response.meta.page - 1) * +response.meta.take +
                            +response.meta.take,
                    });
                    this._rcvs.next(response.data);
                })
            );
    }

    /**
     * Create rcv
     */
    creatercv(): Observable<Rcv> {
        return this.rcvs$.pipe(
            take(1),
            switchMap((rcvs) =>
                this._httpClient
                    .post<Rcv>(`${environment.urlApi}/api/c04`, {})
                    .pipe(
                        map((newRcv) => {
                            // Update the rcvs with the new rcv
                            this._rcvs.next([newRcv, ...rcvs]);

                            // Return the new rcv
                            return newRcv;
                        })
                    )
            )
        );
    }

    addEvent() {}

    addEvent2() {}

    resumeRcv(
        kemp: number,
        fec0: Date,
        fec1: Date,
        kprv: number
    ): Observable<Resume[]> {
        const url =
            `${environment.urlApi}/api/c01/resume/` +
            kemp +
            `/` +
            fec0 +
            `/` +
            fec1 +
            `/` +
            kprv +
            `/frec`;
        console.log('--> resumeRcv()');
        console.log('url', url);
        console.log('kemp', kemp);
        console.log('fec0', fec0);
        console.log('fec1', fec1);
        console.log('kprv', kprv);
        return this._httpClient.get<Resume[]>(url, {}).pipe(
            tap((response) => {
                console.log('--> resumeRcv() response', response);
                //this._pagination.next(response.meta);
                // this._rcvs.next(response.data);
            })
        );
    }

    loadFromSii(
        kemp: number,
        year: string,
        mont: string
    ): Observable<{ data: Rcv }> {
        return this._httpClient
            .get<{ data: Rcv }>(
                `${environment.urlApi}/api/sii/create-update-cmpx/` +
                    kemp +
                    `/` +
                    year +
                    `/` +
                    mont,
                {}
            )
            .pipe(
                tap((response) => {
                    return true;
                    //this._resrcvs.next(null);
                })
            );
    }

    loadFromSiiRcv0(
        kemp: number,
        year: string,
        mont: string
    ): Observable<{ data: Rcv }> {
        return this._httpClient
            .get<{ data: Rcv }>(
                `${environment.urlApi}/api/sii/create-update-rcv/` +
                    kemp +
                    `/` +
                    year +
                    `/` +
                    mont,
                {}
            )
            .pipe(
                tap((response) => {
                    return true;
                    //this._resrcvs.next(null);
                })
            );
    }

    getStatusSiiRcv(
        kemp: number,
        year: string,
        mont: string
    ): Observable<number> {
        return this._httpClient
            .get<number>(
                `${environment.urlApi}/api/sii/status-rcv/` +
                    kemp +
                    `/` +
                    year +
                    `/` +
                    mont,
                {}
            )
            .pipe(
                tap((response) => {
                    return response;
                    //this._resrcvs.next(null);
                })
            );
    }

    getStatusSii(kemp: number, year: string, mont: string): Observable<number> {
        return this._httpClient
            .get<number>(
                `${environment.urlApi}/api/sii/status-cmpx/` +
                    kemp +
                    `/` +
                    year +
                    `/` +
                    mont,
                {}
            )
            .pipe(
                tap((response) => {
                    return response;
                    //this._resrcvs.next(null);
                })
            );
    }

    /** Avance de la importación del RCV en curso (null = ninguna). Lo muestra sii/rcv. */
    readonly importAvance$ = new BehaviorSubject<RcvImportJob | null>(null);

    /**
     * Importa el RCV del período desde el SII. Desde 2026-10-07 en SEGUNDO PLANO:
     * POST /scrapper/jobs/... arranca y responde al instante, y se consulta
     * GET /scrapper/jobs/:id cada 3 s (etapa y X/N en importAvance$) hasta que
     * termina — la primera importación de una empresa nueva puede durar 40+ min
     * y ya no depende de los timeouts del proxy. Emite al final la MISMA forma
     * que antes ({ success, error, rutsNuevos }), así los callers no cambian.
     * Si el scrapper desplegado aún no tiene /jobs (404), usa el GET síncrono.
     */
    loadFromSiiRcvOnDemand(
        kemp: number,
        year: string,
        mnth: string
    ): Observable<any> {
        const apiUrl = '/scrapper/';
        const sincrono = () => this._httpClient.get<any>(`${apiUrl}${kemp}/${year}/${mnth}`, {});
        return this._httpClient.post<RcvImportJob>(`${apiUrl}jobs/${kemp}/${year}/${mnth}`, {}).pipe(
            catchError((err) => (err?.status === 404 ? of(null) : throwError(() => err))),
            switchMap((job) => {
                if (!job) return sincrono();
                this.importAvance$.next(job);
                return timer(3000, 3000).pipe(
                    // exhaustMap: una consulta lenta no se pisa con la siguiente.
                    exhaustMap(() => this._httpClient.get<RcvImportJob>(`${apiUrl}jobs/${job.id}`).pipe(
                        // Un corte puntual de red no aborta la importación (que sigue en el server).
                        retry({ count: 5, delay: 5000 }),
                    )),
                    tap((j) => this.importAvance$.next(j)),
                    filter((j) => j.estado !== 'EN_CURSO'),
                    take(1),
                    map((j) => ({
                        message: j.estado === 'OK' ? 'Scraping terminado' : 'El scraping falló',
                        success: j.estado === 'OK',
                        error: j.estado === 'OK' ? undefined : (j.error || 'El scrapper no pudo completar la lectura del SII'),
                        rutsNuevos: j.rutsNuevos,
                    })),
                );
            }),
            finalize(() => this.importAvance$.next(null)),
        );
    }

    /**
     * Dispara el scrapper de Boletas de Honorarios Electrónicas RECIBIDAS
     * (servicio `read-bhe`, contenedor prp_read_bhe). Mismo mecanismo y forma
     * que loadFromSiiRcvOnDemand: GET con los params en el path.
     *
     * URL RELATIVA `/read-bhe/:kemp/:year/:month` → reverse proxy (dev:
     * proxy.conf.json → :8006; prod: nginx → contenedor interno) — el puerto
     * 8006 NO se expone. El scrapper escribe directo en DOC (tdoc='BHE') + PDF
     * + emisores (PRV sucu='SI'); el front solo recarga la grilla al terminar.
     * Operación larga y síncrona (minutos); el scrapper siempre responde 200.
     */
    loadFromSiiBheOnDemand(kemp, year, month): Observable<any> {
        return this._httpClient.get(
            `/read-bhe/${Number(kemp)}/${Number(year)}/${Number(month)}`
        );
    }

    runScrapperReadCmpOnDemand(kemp: number = 0, rcvs: any): Observable<any> {
        //const url = `http://localhost:8009/scrapper/` + kemp
        const url = `https://prp.api.amazingia.cl:8009/scrapper/` + kemp;
        return this._httpClient.post(url, rcvs);
    }

    runScrapperReadVtaOnDemand(kemp: number = 0, rcvs: any): Observable<any> {
        //const url = `http://localhost:8009/scrapper/` + kemp
        const url = `https://prp.api.amazingia.cl:8008/scrapper/` + kemp;
        return this._httpClient.post(url, rcvs);
    }

    // Facturas de compra pendientes (RCV.OPER='PEN') de un tipo de documento
    // (tdoc) del período — para el modal de "Acuse de Recibo" de sii/rcv.
    // NO empuja a los BehaviorSubjects (_rcvs/_pagination) como getRcv(): es
    // una consulta lateral que no debe pisar la grilla de detalle.
    listPendientesByTdoc(
        kemp: number,
        year: number,
        mnth: number | string,
        tdoc: number,
        rutt: string = ''
    ): Observable<Rcv[]> {
        const url =
            `${environment.urlApi}/api/rcv/list-by-oper/` +
            kemp +
            `/` +
            year +
            `/` +
            mnth +
            `/PEN`;
        return this._httpClient
            .get<{ meta: PaginationApi; data: Rcv[] }>(url, {
                params: {
                    page: '1',
                    take: '10000',
                    orderby: 'nume',
                    order: 'ASC',
                    tdoc: '' + tdoc,
                    ...(rutt ? { rutt } : {}),
                },
            })
            .pipe(map((r) => r.data || []));
    }

    // Envío a Acuse de Recibo — contenedor prp_acus_rec (puerto 8005).
    // URL RELATIVA `/acuse-recibo` → reverse proxy, mismo patrón que read-bhe:
    // prod = nginx de prp.amazingia.cl → 127.0.0.1:8005; dev = proxy.conf.json →
    // https://prp.amazingia.cl. Antes se llamaba directo a
    // https://prp.api.amazingia.cl:8005, que solo respondía dentro de la red
    // local del servidor: desde internet (otras redes, datos móviles) el puerto
    // 8005 está cerrado y el navegador daba "0 Unknown Error" (2026-09-28).
    enviarAcuseRecibo(payload: {
        kemp: number;
        docs: { rut: string; folio: number; tipo: number }[];
        dryRun?: boolean;
    }): Observable<any> {
        return this._httpClient.post(`/acuse-recibo`, payload);
    }

    /** Verificación previa al envío: mismo camino que enviarAcuseRecibo() (proxy
     *  /acuse-recibo → contenedor :8005) con `dryRun: true` y SIN documentos —
     *  el servicio responde {success:true, dryRun:true, solicitados:0} sin
     *  tocar el SII. Si esto no responde, el envío real tampoco llegaría. */
    verificarAcuseRecibo(kemp: number): Observable<any> {
        return this._httpClient
            .post(`/acuse-recibo`, { kemp, docs: [], dryRun: true })
            .pipe(timeout(15000));
    }

    // Conteo total (todos los períodos) de RCV con OPER='PEN' — botón naranjo
    // del header (classy layout), espejo de fevService para "vencidos".
    countPendientes(kemp: number): Observable<number> {
        const url = `${environment.urlApi}/api/rcv/count-pendientes/` + kemp;
        return this._httpClient.get<number>(url);
    }

    /**
     * Conteo de registros RCV de un período/oper — alimenta el "(N)" que se
     * muestra en cada pestaña de sii/rcv. Pide take=1 y lee `meta.itemCount`
     * (el COUNT(*) real del backend). NO toca los BehaviorSubjects del servicio
     * (a diferencia de getRcv()), así puede correr en paralelo para las 3 opers
     * sin pisar la grilla de la pestaña activa.
     */
    countByOper(
        kemp: number,
        year: number,
        mnth: number,
        oper: string,
        rutt: string = '',
    ): Observable<number> {
        const url = `${environment.urlApi}/api/rcv/list-by-oper/${kemp}/${year}/${mnth}/${oper}`;
        return this._httpClient
            .get<{ meta: PaginationApi; data: Rcv[] }>(url, {
                params: {
                    page: '1',
                    take: '1',
                    orderby: 'nume',
                    order: 'ASC',
                    ...(rutt ? { rutt } : {}),
                },
            })
            .pipe(map((r) => +r.meta.itemCount || 0));
    }

    lastUpdate(kemp: number = 0): Observable<any> {
        console.log('--> lastUpdate()');
        const url = `${environment.urlApi}/api/rcv/last-update/`+ kemp;
        return this._httpClient
            .get<any>(url,{}
            )
            .pipe(
                tap((response) => {
                    console.log('response', response);
                    return response;
                })
            );
    }
}
